export enum CryptoAsset {
  BTC = 'BTC',
  ETH = 'ETH',
  USDC = 'USDC',
  SOL = 'SOL',
  MATIC = 'MATIC'
}

export enum FiatCurrency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  CAD = 'CAD'
}
